import { render, staticRenderFns } from "./KanbanSettings.vue?vue&type=template&id=77beca7c&scoped=true"
import script from "./KanbanSettings.vue?vue&type=script&lang=js"
export * from "./KanbanSettings.vue?vue&type=script&lang=js"
import style0 from "./KanbanSettings.vue?vue&type=style&index=0&id=77beca7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77beca7c",
  null
  
)

export default component.exports